import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

export type AppType = 'ieee' | 'asme' | 'landing' | 'unknown';

@Injectable({
  providedIn: 'root'
})
export class ApplicationTypeService {
  private router = inject(Router);

  // An observable that components can subscribe to for real-time changes
  public appType$: Observable<AppType> = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map(event => this.determineAppType(event.urlAfterRedirects)),
    startWith(this.determineAppType(this.router.url))
  );

  // Synchronous helper if you just need a snapshot check
  public getSnapshot(): AppType {
    return this.determineAppType(this.router.url);
  }

  private determineAppType(url: string): AppType {
    if (url.includes('/ieee')) return 'ieee';
    if (url.includes('/asme')) return 'asme';
    if (url.includes('/amba') && !url.includes('/ieee') && !url.includes('/asme')) {
      return 'landing';
    }
    return 'unknown';
  }
}